import { memo } from 'react';

import { CookieOutlined } from '@mui/icons-material';
import { Backdrop, Box, Link, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';

const CookieBannerMobile = ({
  handleAccept,
  handleDecline
}: {
  handleAccept: () => void;
  handleDecline: () => void;
}) => {
  return (
    <Backdrop
      open
      component='div'
      sx={{
        background: 'rgba(18, 22, 63, 0.80)',
        backdropFilter: 'blur(1px)',
        zIndex: 10
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          px: '16px',
          py: '24px',
          width: '100%',
          background: 'var(--GX-Tile-Dark, #0D1228)'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '16px'
          }}
        >
          <Typography
            sx={{
              lineHeight: '30px',
              display: 'flex',
              gap: '8px',
              alignItems: 'center'
            }}
            variant='h3'
          >
            <CookieOutlined sx={{ fontSize: 36 }} />
            Cookies
          </Typography>
          <Box>
            <Typography>
              To ensure the best experience this application uses cookies as outlined in our{' '}
              <Link
                href='https://www.general-index.com/privacy-cookies'
                rel='noopener'
                target='_blank'
                underline='none'
              >
                Privacy Policy
              </Link>
              . Cookies are required for the app to work correctly. Declining cookies will disable
              essential features and you won’t be able to use the app. Do you wish to decline
              cookies?
            </Typography>
          </Box>
          <Button
            startIcon={<CookieOutlined />}
            variant='contained'
            onClick={handleAccept}
          >
            Accept Cookies
          </Button>
          <Button
            variant='outlined'
            onClick={handleDecline}
          >
            Decline
          </Button>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default memo(CookieBannerMobile);
